import { Modal, Input, Button, Rate } from "antd";
import React from "react";
import { useState } from "react";
import './RateCandidateSessionModal.css'

import { getImage } from "../../../../../../../utilities/storageOperations/downloadURL";
import history from "../../../../../../../routes/history";
import { useEffect } from "react";
import { replaceGigWithJob } from "../../../../../../../shared/helpers";

const RateCandidateSessionModal = ({ ratingData, visible, setVisible }) => {

    const [profilePic, setProfilePic] = useState("");
    const [job_title, setJob_title] = useState("Gig title");
    const [candidate_name, setCandidate_name] = useState("Candidate name");

    useEffect(() => {

        if (ratingData?.candidate.profile?.PictureUrl) {

            getImage(ratingData?.candidate?.profile?.PictureUrl
            )
                .then((result) => {
                    setProfilePic(result);
                })
                .catch(() => {
                });

        }

        if (ratingData?.candidate.profile?.JobTitle) {
            setJob_title(ratingData?.candidate.profile?.JobTitle)
        }
        if (ratingData?.candidate.name) {
            setCandidate_name(ratingData?.candidate.name)
        }



    }, [ratingData])

    function onCancelHandler() {
        setVisible(false)
    }

    return (
        <Modal title={<h3><b>Rate candidate</b></h3>}
            visible={visible}
            onCancel={onCancelHandler}
            okText='Submit Reason'
            centered
            footer={[
                <button key='submit' onClick={onCancelHandler}
                    className="rateCandidateModalFooterButton"
                >Skip for later</button>
            ]}
        >
            <div className="rateCandidateModalContainer">


                <div className="rateModalText">Your assignment has come to an end.<br />
                    How would you rate your overall experience with this Candidate?</div>

                <div style={{padding: "10px"}}>
                    {profilePic != "" ?
                        <img className="recipent_image_rating" src={profilePic} />
                        :
                        <div className='image-circle-filled-'>{candidate_name.split("")[0].toUpperCase()}</div>
                    }
                </div>
                
                <div className="Ratings-Job-CandidateName-Container">
                    <div className="Ratings-Candidate-Name-">{candidate_name}</div>
                    <div className="Ratings-Job-Title-">{replaceGigWithJob(job_title)}</div>
                </div>

                <div onClick={() => {

                    history.push({
                        pathname: '/ratings',
                        state: {
                            bidId: ratingData.BidId,
                            image: ratingData?.candidate.profile?.PictureUrl,
                            candidate_name: ratingData?.candidate.name,
                            job_title: ratingData?.candidate.profile?.JobTitle,
                            rating: false,
                            previousScreen: 'Dashboard',
                            isEdit: false
                        },
                    })
                }}>

                    <Rate className="candidateSessionRating" defaultValue={0} onChange={() => { }} value={0} />
                </div>

            </div>
        </Modal>
    )
}
export default RateCandidateSessionModal